import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createSentryPiniaPlugin } from '@sentry/vue'
import {IntlService} from "@progress/kendo-vue-intl";
import * as Sentry from "@sentry/vue";
import { VueFire, VueFireAuth } from 'vuefire'
import { firebaseApp } from './firebase'

import App from './App.vue'
import router from './router'

import VueCookies from 'vue-cookies'

// import "bootstrap/dist/js/bootstrap.bundle.js"
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css'
import '@fortawesome/fontawesome-pro/css/light.min.css'
import '@fortawesome/fontawesome-pro/css/solid.min.css'
import '@fortawesome/fontawesome-pro/css/brands.min.css'
import '@/assets/app.scss'
import '@/assets/print.scss'

import * as bootstrap from 'bootstrap';
import { ApiDataProvider } from '@/api/ApiDataProvider';

const app = createApp(App)

app.use(VueFire, {
    // imported above but could also just be created here
    firebaseApp,
    modules: [
        // we will see other modules later on
        VueFireAuth(),
    ],
})

app.provide('kendo', new IntlService('en-US'))
app.provide('bootstrap', bootstrap)
app.provide('apiDataProvider', new ApiDataProvider())

const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());

app.use(pinia)

if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        sendDefaultPii: true,
        integrations: [
            Sentry.vueIntegration({
                tracingOptions: {
                    trackComponents: true,
                }
            }),
            Sentry.browserTracingIntegration({ router }),
        ]
    });
}

app.use(router)
   .use(VueCookies, { expires: '1y'})

app.mount('#app')
